import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { FinishInstantPayDirectDepositSwitchRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { FinishInstantPayDirectDepositSwitchResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const finishInstantPayDirectDepositSwitch = (
  request: FinishInstantPayDirectDepositSwitchRequest,
  options?: CashRequestOptions
) =>
  post<FinishInstantPayDirectDepositSwitchRequest, FinishInstantPayDirectDepositSwitchResponse>(
    '/2.0/cash/finish-instant-pay-direct-deposit-switch',
    request,
    { ...options, rejectOnError: true }
  )
